import './ReactArticleCarousel.scss'
import { Placeholder } from '../../shared/ReactBootstrap'

const ReactArticleCarouselSkeleton = () => {
  return (
    <div className='article'>
      <div className='article-container responsive-size' data-testid='article-container'>
        <div key='image-container' className='image-container'>
          <div key='image-placeholder' className='image-placeholder' />

          {
            <div key='badge' className='badge'>
              <Placeholder
                as={'span'}
                style={{ height: '20px', width: '100px', backgroundColor: 'grey', borderRadius: '20px' }}
              />
            </div>
          }
          <Placeholder className='heading' xs={2} />
        </div>
        <Placeholder className='headingDescription' xs={3} />
        <div key='linkContainer' className='linkContainer' data-testid='link-container'>
          <Placeholder className='linkText' xs={2} />
          <div style={{ backgroundColor: 'grey', height: '16px', width: '16px', marginLeft: '5px' }} />
        </div>
      </div>
    </div>
  )
}

export default ReactArticleCarouselSkeleton
